<template>
  <div class="home">
    <!-- <p class='small'>: )</p> -->
    <!-- <img src='@assets/logo.png'> -->
    <p>遇见你,真美好</p>
    <p>{{dateNow}} 星期{{dateWeek}}</p>
  </div>
</template>
<script>
  import { computed } from 'vue';
  import format from '@assets/js/format'

  export default {
    name: 'home',
    components: {
      
    },
    setup(){

      const dateNow = computed(()=>{
          return format.formatDate(new Date());
      })
      const dateWeek = computed(()=>{
          let tmpnewchar = ""
          switch (new Date().getDay() + '') {
              case "0": tmpnewchar = "天";break;
              case "1": tmpnewchar =  "一";break;
              case "2": tmpnewchar =  "二";break;
              case "3": tmpnewchar =  "三";break;
              case "4": tmpnewchar =  "四";break;
              case "5": tmpnewchar =  "五";break;
              case "6": tmpnewchar =  "六";break;
          }
          return tmpnewchar;
      })
      return {
        dateNow,
        dateWeek,
      }
    },
  
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .home{
    display: flex;
    justify-content: center;
    padding-top:10%;
    flex-direction: column;
    align-items: center;
    font-size:25px ;
   
    p{
       margin-top: 30px;
       margin-bottom: 0;
    }
    img{
      width: 300px;
      margin-bottom: 40px;
    }
    .small{
      font-size: 200px;
    }
  }
</style>